import { useEffect, useState } from 'react';
import { ensure } from '../store/busesSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useModals } from '@mattjennings/react-modal-stack';
import { URL_PREFIX } from '../api';
import axios from 'axios';
import { toast } from 'react-toastify';

function ImagePickerModal({ open, title, url, callback = null }) {
    const { closeModal: __closeModal } = useModals();
    const dispatch = useDispatch();
    const closeModal = () => {
        callback && callback();
        __closeModal();
        toast.success("Pilt edukalt üles laetud!");
    };

    // ###### UPLOADING ######

    const [file, setFile] = useState(null);

    const handleFileChange = (e) => {
        console.log("valiti fail:", e.target.files[0]);
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        try {
            const formData = new FormData();
            formData.append('image', file);

            await axios.post(URL_PREFIX + url, formData, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log('File uploaded successfully');
        } catch (error) {
            console.error('Error uploading file', error);
        }

        closeModal();
    };

    if (!open) {
      return null;
    }
  
    return (
        <div className='modal'>
            <div className='container column'>
                <input id={"picker"+title+url} type="file" onChange={handleFileChange} style={{ display: 'none' }} />
                <div className="row center-cross g16 p16">
                    <div className="column grow">
                        <h2>Pildi üleslaadimine</h2>
                        <p>{title}</p>
                    </div>

                    <button
                        onClick={() => {
                            closeModal()
                        }}
                        style={{
                            padding: 8
                        }}
                    >
                        <svg height="12" width="12" xmlns="http://www.w3.org/2000/svg" fill="#666" version="1.1" id="Capa_1" viewBox="0 0 490 490" >
                            <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490   489.292,457.678 277.331,245.004 489.292,32.337 "/>
                        </svg>
                    </button>
                </div>
                
                <div className="hr"></div>
                
                <div className="column center-cross p32 g16 w100">

                    { file && <img
                        className='w100'
                        src={URL.createObjectURL(file)}
                        style={{ borderRadius: 8, backgroundColor: '#ddd', objectFit: 'contain', height: 320 }}
                    /> }

                    <p>{ file ? file.name : "Faili pole valitud"}</p>
                    
                    <label className='button w100' htmlFor={"picker"+title+url}>Ava fail seadmest</label>
                </div>
                <div className="hr"></div>
                <div className="column p32 g16">

                    <button onClick={handleUpload}>Salvesta</button>

                </div>
                
                
            </div>
        </div>
    );
}

export default ImagePickerModal;